var filter = {};

filter = {

  init: function () {
    const me = this;
    const filters = document.querySelectorAll('.js-filter');
    const filterClear = document.querySelector('.filter__clear');
    const courseGroup = document.querySelectorAll('.js-filter-item'); 
    let filterList = [];

    if (filterClear) {

      filterClear.addEventListener('click', e => {
        const selectedFilters = document.querySelectorAll('.filter-is--selected');
        const hiddenItems = document.querySelectorAll('.filter--hide');

        filterList = [];
        filterClear.classList.add('hide');

        selectedFilters.forEach(selected => {
          selected.classList.remove('filter-is--selected');
        });

        hiddenItems.forEach(item => {
          item.classList.remove('filter--hide');
        });
      })

    }

    if (filters) {
      Array.prototype.forEach.call(filters, (filter, index) => {

        filter.addEventListener('click', e => {

          if (!e.target.classList.contains('filter-is--selected')) {

            Array.prototype.forEach.call(filters, (filter, index) => {
              filter.classList.remove('filter-is--selected');
            })

            const filterValue = e.target.getAttribute('data-filter');

            filterList.push(filterValue);
                
            Array.prototype.forEach.call(courseGroup, (course, index) => {

              const courseFilterVal = course.getAttribute("data-filter");

              if(courseFilterVal != null && courseFilterVal.length > 0) {

                filterList.filter(e => {

                  if(!courseFilterVal.includes(e)) {
                    course.classList.add('filter--hide');
                  } else {
                    course.classList.remove('filter--hide');

                  }

                })

              }
            })

            filter.classList.add('filter-is--selected');
            const clearFilter = document.querySelector('.filter__clear');
            if (clearFilter) {
              clearFilter.classList.remove('hide');
            }

          } else {

            filter.classList.remove('filter-is--selected');
            
            const clearFilter = document.querySelector('.filter__clear');
            if (clearFilter) {
              clearFilter.classList.add('hide');
            }
            courseGroup.forEach(item => {
              item.classList.remove('filter--hide');
            })

          }
        })
      });
    }

  }
};

filter.initialize = function () {
  filter.init();
};

module.exports = filter;
